// ***********************************
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { IStores, IStoresInject } from '../../../Types/interfaces';
import Legend from '../../Controls/Legend/legend';
import BodyDaily from './Body/body';
import ScheduleNav from './ScheduleNav/schedulenav';
import Settings from './Settings/settings';
// ***********************************
interface IProps extends IStoresInject { hide:boolean; }
// ***********************************
@inject((stores: IStores): IStoresInject => ({ ...stores }))
@observer export default class ViewDaily extends React.Component<IProps,{}> {
  //***********************
  render(){
    const{viewState}=this.props;

    let baseStyle=this.props.hide?{display:'none'}:{};

    return(
      <div id="defaultView" style={baseStyle}>
        <Settings />
        <ScheduleNav listener={true}/>
        <BodyDaily />
        <ScheduleNav />
        <Legend genreList={viewState!.genreList}/>
      </div>
    );
  }
  //***********************
}
// ***********************************